// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerFormatsConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

import UIConstants from 'logic/data/Izenda.UIConstants';
const FORMAT_GROUP_CONFIG = {
  FILTER: 'filter',
  HEADER: 'reportHeader',
  FOOTER: 'reportFooter',
  TITLE_DESCRIPTION: 'reportTitleDescription'
};

const DEFAULT_ITEM_MIN_HEIGHT = 1;

const FORMAT_GROUP = [
  {
    get label() {
      return localizer.getText('REPORTDESIGNER_LABEL_FIELDS_FILTERS_HEADER');
    },
    value: FORMAT_GROUP_CONFIG.FILTER
  },
  {
    get label() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_HEADER');
    },
    value: FORMAT_GROUP_CONFIG.HEADER
  },
  {
    get label() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_TITLE_DESCRIPTION');
    },
    value: FORMAT_GROUP_CONFIG.TITLE_DESCRIPTION
  },
  {
    get label() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_FOOTER');
    },
    value: FORMAT_GROUP_CONFIG.FOOTER
  }
];

/*Default value for format item*/
const ITEMS_TYPE = {
  image: {
    value: 'image',
    get label() {
      return localizer.getText('COMMON_DATA_TYPE_IMAGE');
    },
    defaultName: 'image',
    defaultValue: '',
    width: 6,
    height: 6,
    imageUrl: 'http://',
    defaultImgBtn: 'button',
    imageDimensions:{
      imageWidth: 1,
      imageHeight: 1,
      isConstrainProportions:true
    },
    
  },
  text: {
    value: 'text',
    get label() {
      return localizer.getText('COMMON_DATA_TYPE_TEXT');
    },
    defaultName: 'text',
    defaultValue: '',
    width: 8,
    height: 2,
    minHeight: 2
  },
  horizontalRule: {
    value: 'horizontalRule',
    get label() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_ITEMS_TYPE_HORIZONTAL_RULE');
    },
    defaultName: 'horizontalRule',
    defaultValue: '{horizontalRule}',
    width: 12,
    height: 1
  },
  thinHorizontalRule: {
    value: 'thinHorizontalRule',
    get label() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_ITEMS_TYPE_HORIZONTAL_RULE');
    },
    defaultName: 'horizontalRule',
    defaultValue: '{horizontalRule}',
    width: 16,
    height: 1
  },
  verticalRule: {
    value: 'verticalRule',
    get label() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_ITEMS_TYPE_VERTICAL_RULE');
    },
    defaultName: 'verticalRule ',
    defaultValue: '{verticalRule}',
    width: 1,
    height: 5
  },
  dateTime: {
    value: 'dateTime',
    get label() {
      return localizer.getText('COMMON_LABEL_DATE_TIME');
    },
    defaultName: 'currentDateTime',
    defaultValue: '{currentDateTime}',
    width: 8,
    height: 2,
    minHeight: 2
  },
  pageNumber: {
    value: 'pageNumber',
    get label() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_ITEMS_TYPE_PAGE_NUMBER');
    },
    defaultName: 'pageNumber',
    defaultValue: '{pageNumber}',
    width: 8,
    height: 2,
    minHeight: 2
  },
  title: {
    value: 'title',
    get label() {
      return localizer.getText('COMMON_LABEL_TITLE');
    }
  },
  description: {
    value: 'description',
    get label() {
      return localizer.getText('COMMON_LABEL_DESCRIPTION');
    }
  }
};

/*Property option by format type*/
const OPTIONS_BY_FORMAT_TYPE = {
  image: {
    type: ITEMS_TYPE.image.value,
    label: ITEMS_TYPE.image.label,
    name: '',
    imageUrl: ITEMS_TYPE.image.imageUrl,
    defaultImgBtn: ITEMS_TYPE.image.defaultImgBtn,
    imageDimensions:{
      imageWidth: 1,
      imageHeight: 1,
      isConstrainProportions:true
    },
  },
  text: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    name: '',
    value: '',
    fontFormat: {},
    fontStyle: {},
    alignment: null
  },
  dateTime: {
    type: ITEMS_TYPE.dateTime.value,
    label: ITEMS_TYPE.dateTime.label,
    name: '',
    value: '',
    format: null,
    fontFormat: {},
    fontStyle: {},
    alignment: null
  },
  pageNumber: {
    type: ITEMS_TYPE.pageNumber.value,
    label: ITEMS_TYPE.pageNumber.label,
    name: '',
    value: '',
    format: null,
    fontFormat: {},
    fontStyle: {},
    alignment: null
  },
  horizontalRule: {
    type: ITEMS_TYPE.horizontalRule.value,
    label: ITEMS_TYPE.horizontalRule.label,
    name: '',
    value: '',
    color: '',
    dashStyle: '',
    thickness: 1
  },
  thinHorizontalRule: {
    type: ITEMS_TYPE.thinHorizontalRule.value,
    label: ITEMS_TYPE.thinHorizontalRule.label,
    name: '',
    value: '',
    color: '',
    dashStyle: '',
    thickness: 1
  },
  verticalRule: {
    type: ITEMS_TYPE.verticalRule.value,
    label: ITEMS_TYPE.verticalRule.label,
    name: '',
    value: '',
    color: '',
    dashStyle: '',
    thickness: 1
  },
  title: {
    get label() {
      return localizer.getText('COMMON_LABEL_TITLE');
    },
    fontFormat: {},
    fontStyle: {},
    alignment: null
  },
  description: {
    get label() {
      return localizer.getText('COMMON_LABEL_DESCRIPTION');
    },
    fontFormat: {},
    fontStyle: {},
    alignment: null
  }
};

/*List option add item*/
const ITEMS = [
  {
    value: ITEMS_TYPE.image.value,
    get label() {
      return ITEMS_TYPE.image.label;
    }
  },
  {
    value: ITEMS_TYPE.text.value,
    get label() {
      return ITEMS_TYPE.text.label;
    }
  },
  {
    value: ITEMS_TYPE.dateTime.value,
    get label() {
      return ITEMS_TYPE.dateTime.label;
    }
  },
  {
    value: ITEMS_TYPE.pageNumber.value,
    get label() {
      return ITEMS_TYPE.pageNumber.label;
    }
  },
  {
    value: ITEMS_TYPE.horizontalRule.value,
    get label() {
      return ITEMS_TYPE.horizontalRule.label;
    }
  },
  {
    value: ITEMS_TYPE.verticalRule.value,
    get label() {
      return ITEMS_TYPE.verticalRule.label;
    }
  }
];

/*Default header items*/
const HEADER_ITEMS = {
  image: {
    type: ITEMS_TYPE.image.value,
    label: ITEMS_TYPE.image.label,
    positionX: 0,
    positionY: 0,
     width: 6,
     height: 6,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_LOGO_IMAGE');
    },
    value: '',
    imageUrl: 'http://',
    imageDimensions:{
      imageWidth: 1,
      imageHeight: 1,
      isConstrainProportions:true
    },
  },
  reportName: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 0,
    width: 12,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('COMMON_LABEL_REPORT_NAME');
    },
    value: '{reportName}'
  },
  upperSeparatorLine: {
    type: ITEMS_TYPE.thinHorizontalRule.value,
    label: ITEMS_TYPE.thinHorizontalRule.label,
    positionX: 20,
    positionY: 4,
    width: 12,
    height: 1,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_UPPER_SEPARATOR_LINE');
    },
    value: '{horizontalRule}',
    thickness: 2,
    color: UIConstants.borderColor
  },
  reportGenerate: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 5,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_GENERATED');
    },
    value: 'Report Generated:'
  },
  user: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 7,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_USER');
    },
    value: 'User:'
  },
  tenant: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 9,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('COMMON_LABEL_TENANT');
    },
    value: 'Tenant:'
  },
  currentDateTime: {
    type: ITEMS_TYPE.dateTime.value,
    label: ITEMS_TYPE.dateTime.label,
    positionX: 26,
    positionY: 5,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.dateTime.minHeight,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_CURRENT_DATE_TIME');
    },
    value: '{currentDateTime}'
  },
  currentUserName: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 26,
    positionY: 7,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_CURRENT_USER_NAME');
    },
    value: '{currentUserName}'
  },
  tenantName: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 26,
    positionY: 9,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('COMMON_LABEL_TENANT_NAME');
    },
    value: '{tenantName}'
  },
  lowerSeparatorLine: {
    type: ITEMS_TYPE.horizontalRule.value,
    label: ITEMS_TYPE.horizontalRule.label,
    positionX: 0,
    positionY: 11,
    width: 32,
    height: 1,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_LOWER_SEPARATOR_LINE');
    },
    value: '{horizontalRule}',
    thickness: 4,
    color: UIConstants.borderColor
  }
};

/*Default footer value*/
const FOOTER_ITEMS = {
  separatorLine: {
    type: ITEMS_TYPE.horizontalRule.value,
    label: ITEMS_TYPE.horizontalRule.label,
    positionX: 0,
    positionY: 0,
    width: 32,
    height: 1,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_SEPARATOR_LINE');
    },
    value: '{horizontalRule}',
    thickness: 4,
    color: UIConstants.borderColor
  },
  footerText: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 0,
    positionY: 1,
    width: 10,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_FOOTER_TEXT');
    },
    value: 'Footer Text'
  },
  page: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 1,
    width: 4,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_PAGE');
    },
    value: 'Page'
  },
  pageNumber: {
    type: ITEMS_TYPE.pageNumber.value,
    label: ITEMS_TYPE.pageNumber.label,
    positionX: 24,
    positionY: 1,
    width: 8,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_PAGE_NUMBER');
    },
    value: '{pageNumber}'
  }
};

const TITLE_DESCRIPTION_ITEMS = {
  title: {
    type: ITEMS_TYPE.title.value,
    label: ITEMS_TYPE.title.label,
    name: ITEMS_TYPE.title.label,
    value: ''
  },
  description: {
    type: ITEMS_TYPE.description.value,
    label: ITEMS_TYPE.description.label,
    name: ITEMS_TYPE.description.label,
    value: ''
  }
};

const MESSAGES = {
  get M01() {
    return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_MESSAGES_ITEM_NAME_EXISTS');
  }
};

export default {
  FORMAT_GROUP_CONFIG,
  FORMAT_GROUP,
  get TITLE() {
    return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_TITLE_REPORT_FORMATTING');
  },
  HEADER_FOOTER: {
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_HEADER_FOOTER');
    },
    items: ITEMS
  },
  GRID_ROWS_COLUMNS: 15,
  TITLE_DESCRIPTION: {
    get name() {
      return localizer.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_TITLE_DESCRIPTION');
    }
  },
  NUMBER_HEADER_COLS: 32,
  NUMBER_HEADER_ROWS: 12,
  NUMBER_FOOTER_COLS: 32,
  NUMBER_FOOTER_ROWS: 5,
  ROW_HEIGHT: 25,
  ITEMS_TYPE,
  reportHeader: HEADER_ITEMS,
  reportFooter: FOOTER_ITEMS,
  reportTitleDescription: TITLE_DESCRIPTION_ITEMS,
  OPTIONS_BY_FORMAT_TYPE,
  MESSAGES,
  DEFAULT_ITEM_MIN_HEIGHT
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportDesignerFormatsConstants.js